import { requestList, orgBase } from '@/api/http'
import type { StandardOption } from '@/api/types'

export const standardsApi = {
  // Compliance standards sourced from qtz-discovery (empty when discovery is disabled).
  list(orgId: string): Promise<StandardOption[]> {
    return requestList(`${orgBase(orgId)}/standards`)
  },
}
